import {
	DEV_SERVICE_WORKER_RELOAD_FLAG,
	shouldRunDevServiceWorkerCleanup,
	shouldUnregisterDevServiceWorker,
} from 'src/util/pwa/devServiceWorkerCleanup';

const cleanupServiceWorkersForSpaDev = async (): Promise<void> => {
	if (
		typeof window === 'undefined' ||
		!('serviceWorker' in navigator) ||
		!shouldRunDevServiceWorkerCleanup(process.env.DEV, process.env.MODE)
	) {
		return;
	}

	const registrations = await navigator.serviceWorker.getRegistrations();
	const staleRegistrations = registrations.filter((registration) => {
		const scriptUrl =
			registration.active?.scriptURL ??
			registration.waiting?.scriptURL ??
			registration.installing?.scriptURL ??
			'';

		return shouldUnregisterDevServiceWorker(scriptUrl);
	});

	if (staleRegistrations.length === 0) {
		window.sessionStorage.removeItem(DEV_SERVICE_WORKER_RELOAD_FLAG);
		return;
	}

	await Promise.all(staleRegistrations.map((registration) => registration.unregister()));

	if (window.sessionStorage.getItem(DEV_SERVICE_WORKER_RELOAD_FLAG) === '1') {
		return;
	}

	window.sessionStorage.setItem(DEV_SERVICE_WORKER_RELOAD_FLAG, '1');
	window.location.reload();
};

export async function bootDevServiceWorkerCleanup(): Promise<void> {
	await cleanupServiceWorkersForSpaDev();
}
